import { useQuery } from "@apollo/client";

import { GET_WELL_LIST_RECORDS } from "api/userArps";

import { UserArpsItem, WellListRecordCollection } from "models/UserArpsModel";

import { ForecastWellListRecords } from "components/project/forecasts/ForecastWellListRecords";

interface TypeWellEditorWellListProps {
  arpsItem: UserArpsItem;
}

function TypeWellEditorWellList({ arpsItem }: TypeWellEditorWellListProps) {
  const { data: wellListRecordData, loading: isWellListRecordLoading } =
    useQuery<WellListRecordCollection>(GET_WELL_LIST_RECORDS, {
      variables: {
        forecastId: arpsItem?.id
      }
    });

  return (
    <ForecastWellListRecords
      data={wellListRecordData}
      isLoading={isWellListRecordLoading}
      forecastId={arpsItem?.id}
    />
  );
}

export default TypeWellEditorWellList;
